module.exports = __webpack_public_path__ + "static/media/refundCancelAlert.ac982f10.svg";